import React, { Component } from 'react'
import { graphql } from '@apollo/client/react/hoc'
import { Table, UncontrolledTooltip, UncontrolledPopover, PopoverHeader, PopoverBody, Badge } from 'reactstrap'
import moment from 'moment'
import gql from 'graphql-tag'
import PrimaryListingContainer from "../Material/PrimaryListingContainer"
import { Link } from 'react-router-dom'

const AllSubrogationClaimsQuery = gql`
query AllSubrogationClaimsQuery($orderBy: [String],$first: Int!,$cursor: String,$searchTerm: String,$tpaId: ID,$status: String,$inLitigation: Boolean,$incidentBranchIds: [ID],$incidentDate: Date,$dateAddedGte: Date,$dateAddedLte: Date,$requestedAmountGte: Float,$requestedAmountLte: Float,$grossCollectedGte: Float,$grossCollectedLte: Float,$isArchived: Boolean, $externalIdIsNull: Boolean) {
    allSubrogationClaims(orderBy: $orderBy,first: $first,after: $cursor,searchTerm: $searchTerm,tpaId: $tpaId,status: $status,inLitigation: $inLitigation,incidentBranchIds: $incidentBranchIds,incidentDate: $incidentDate,dateAddedGte: $dateAddedGte,dateAddedLte: $dateAddedLte,requestedAmountGte: $requestedAmountGte,requestedAmountLte: $requestedAmountLte,grossCollectedGte: $grossCollectedGte,grossCollectedLte: $grossCollectedLte,isArchived: $isArchived, externalIdIsNull: $externalIdIsNull) {
        edges {
            node {
                id
                pk
                dateAdded
                filedDate
                acknowledgmentDate
                externalId
                paymentId
                status
                inLitigation
                requestedAmount
                grossCollected
                netCollected
                tpaExpenses
                estimatedPd
                estimatedDv
                estimatedTs
                estimatedLou
                recoveredPd
                recoveredDv
                recoveredTs
                recoveredLou
                isArchived
                tpa {
                    id
                    name
                }
                adjuster {
                    id
                    name
                }
                party {
                    id
                    partyName
                }
                incident {
                    id
                    title
                    incidentDate
                    branch {
                        id
                        name
                    }
                }
            }
        }
        pageInfo {
            endCursor
            hasNextPage
            length
        }
    }
    subrogationStatusChoices: __type(name: "IncidentsSubrogationClaimStatusChoices") {
        enumValues {
            name
            description
        }
    }
}
`

class SubrogationClaimList extends Component {
    getStatusBadgeClass = (status) => {
        switch (status) {
            case "OPEN":
                return "SubrogationClaimList-statusBadge is-open"
            case "IN_PROGRESS":
                return "SubrogationClaimList-statusBadge is-in-progress"
            case "CLOSED":
                return "SubrogationClaimList-statusBadge is-closed"
            case "UNSUCCESSFUL":
                return "SubrogationClaimList-statusBadge is-unsuccessful"
            default:
                return "SubrogationClaimList-statusBadge"
        }
    }

    formatCurrency = (value) => {
        if (value === null || value === undefined || value === '') {
            return '--'
        }
        return `$${value}`
    }

    renderAmountPopover = ({ targetId, title, values }) => (
        <>
            <span id={targetId} style={{ textDecoration: 'underline', cursor: 'pointer' }}>
                {this.formatCurrency(values.total)}
            </span>
            <UncontrolledPopover trigger="hover" placement="top" target={targetId}>
                <PopoverHeader>{title}</PopoverHeader>
                <PopoverBody>
                    <div>PD: {this.formatCurrency(values.pd)}</div>
                    <div>DV: {this.formatCurrency(values.dv)}</div>
                    <div>TS: {this.formatCurrency(values.ts)}</div>
                    <div>LOU: {this.formatCurrency(values.lou)}</div>
                </PopoverBody>
            </UncontrolledPopover>
        </>
    )

    render() {
        return (
            <PrimaryListingContainer
                listLoading={this.props.loading}
                loadMoreEntries={this.props.allSubrogationClaims && this.props.allSubrogationClaims.pageInfo.hasNextPage ? this.props.loadMoreEntries : null}
                totalFetchedRows={this.props.allSubrogationClaims && this.props.allSubrogationClaims.edges.length}
                pageInfo={this.props.allSubrogationClaims && this.props.allSubrogationClaims.pageInfo}
                refetchListQuery={this.props.refetchQuery}
            >
                <Table responsive>
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th className='actions-th'>Actions</th>
                            {this.props.columnConfig?.filter(col => col?.preferenceSettings?.isVisible).map((column) => (
                                column.sortable ?
                                    <th key={column.id} onClick={() => this.props.updateOrder(column.id)} style={{ cursor: "pointer" }}>
                                        {this.props.orderBy.some(order => order.includes(column.id)) ? <i className={"fa " + (this.props.orderBy.includes(column.id) ? 'fa-sort-asc' : 'fa-sort-desc')}></i> : <i className='fa fa-sort'></i>}
                                        &nbsp;&nbsp;{column.name}
                                    </th> :
                                    <th key={column.id}>{column.name}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {this.props.allSubrogationClaims && this.props.allSubrogationClaims.edges && this.props.allSubrogationClaims.edges.length > 0 ?
                            this.props.allSubrogationClaims.edges.map((claim, i) =>
                                <tr key={claim.node.id}>
                                    <td>{i + 1}</td>
                                    <td className='actions-td'>
                                        {claim.node.incident?.id ?
                                            <Link to={`/incident/${claim.node.incident.id}#claims`} target="_blank">
                                                <i id={`subrogationClaimDetails${i}`} className="fa fa-external-link" aria-hidden="true" />
                                                <UncontrolledTooltip target={`subrogationClaimDetails${i}`} placement="bottom">View Incident Claims</UncontrolledTooltip>
                                            </Link> :
                                            <span className="null-val-color">--</span>
                                        }
                                    </td>
                                    {this.props.columnConfig?.filter(column => column?.preferenceSettings?.isVisible).map(column => <React.Fragment key={column.id}>
                                        {column.id === "date_added" && <td>{claim.node.dateAdded ? moment(claim.node.dateAdded).format("MM/DD/YYYY") : <span className="null-val-color">--</span>}</td>}
                                        {column.id === "claim_number" && <td>{claim.node.externalId || <span className="null-val-color">--</span>}</td>}
                                        {column.id === "payment_id" && <td>{claim.node.paymentId || <span className="null-val-color">--</span>}</td>}
                                        {column.id === "status" &&
                                            <td>
                                                {claim.node.status ?
                                                    <Badge className={this.getStatusBadgeClass(claim.node.status)}>
                                                        {this.props.subrogationStatusChoices?.enumValues.find(item => item.name === claim.node.status)?.description || claim.node.status}
                                                    </Badge>
                                                    : <span className="null-val-color">--</span>}
                                            </td>
                                        }
                                        {column.id === "tpa" && <td>{claim.node.tpa?.name || <span className="null-val-color">--</span>}</td>}
                                        {column.id === "adjuster" && <td>{claim.node.adjuster?.name || <span className="null-val-color">--</span>}</td>}
                                        {column.id === "party" && <td>{claim.node.party?.partyName || <span className="null-val-color">--</span>}</td>}
                                        {column.id === "incident_name" && <td>{claim.node.incident?.title || <span className="null-val-color">--</span>}</td>}
                                        {column.id === "incident_date" && <td>{claim.node.incident?.incidentDate ? moment(claim.node.incident.incidentDate).format("MM/DD/YYYY") : <span className="null-val-color">--</span>}</td>}
                                        {column.id === "filed_date" && <td>{claim.node.filedDate ? moment(claim.node.filedDate).format("MM/DD/YYYY") : <span className="null-val-color">--</span>}</td>}
                                        {column.id === "acknowledgment_date" && <td>{claim.node.acknowledgmentDate ? moment(claim.node.acknowledgmentDate).format("MM/DD/YYYY") : <span className="null-val-color">--</span>}</td>}
                                        {column.id === "incident_branch" &&
                                            <td>
                                                {claim.node.incident?.branch?.name ?
                                                    <span className="bos-branch-badge">{claim.node.incident.branch.name}</span>
                                                    : <span className="null-val-color">--</span>}
                                            </td>
                                        }
                                        {column.id === "in_litigation" && <td>{claim.node.inLitigation ? "Yes" : "No"}</td>}
                                        {column.id === "requested_amount" &&
                                            <td>
                                                {this.renderAmountPopover({
                                                    targetId: `requestedAmountBreakdown${i}`,
                                                    title: "Requested Amount",
                                                    values: {
                                                        total: claim.node.requestedAmount,
                                                        pd: claim.node.estimatedPd,
                                                        dv: claim.node.estimatedDv,
                                                        ts: claim.node.estimatedTs,
                                                        lou: claim.node.estimatedLou,
                                                    },
                                                })}
                                            </td>
                                        }
                                        {column.id === "gross_collected" &&
                                            <td>
                                                {this.renderAmountPopover({
                                                    targetId: `grossCollectedBreakdown${i}`,
                                                    title: "Gross Collected",
                                                    values: {
                                                        total: claim.node.grossCollected,
                                                        pd: claim.node.recoveredPd,
                                                        dv: claim.node.recoveredDv,
                                                        ts: claim.node.recoveredTs,
                                                        lou: claim.node.recoveredLou,
                                                    },
                                                })}
                                            </td>
                                        }
                                        {column.id === "net_collected" && <td>{this.formatCurrency(claim.node.netCollected)}</td>}
                                        {column.id === "tpa_expenses" && <td>{this.formatCurrency(claim.node.tpaExpenses)}</td>}
                                    </React.Fragment>
                                    )}
                                </tr>
                            ) : !this.props.loading && <tr>
                                <td colSpan={10}>No subrogation claims found!</td>
                            </tr>
                        }
                    </tbody>
                </Table>
            </PrimaryListingContainer>)
    }
}

export default graphql(AllSubrogationClaimsQuery, {
    options: ({ orderBy, searchTerm, tpaId, status, inLitigation, incidentBranchIds, incidentDate, dateAddedGte, dateAddedLte, requestedAmountGte, requestedAmountLte, grossCollectedGte, grossCollectedLte, isArchived, externalIdIsNull }) => ({
        variables: { first: 30, orderBy, searchTerm, tpaId, status, inLitigation, incidentBranchIds, incidentDate, dateAddedGte, dateAddedLte, requestedAmountGte, requestedAmountLte, grossCollectedGte, grossCollectedLte, isArchived, externalIdIsNull },
        notifyOnNetworkStatusChange: true,
        fetchPolicy: 'network-only'
    }),
    props: ({ data: { loading, allSubrogationClaims, fetchMore, variables, subrogationStatusChoices } }) => ({
        loading,
        allSubrogationClaims,
        variables,
        subrogationStatusChoices,
        refetchQuery: () => {
            let currentLength = allSubrogationClaims && allSubrogationClaims.edges ? allSubrogationClaims.edges.length : 30
            return fetchMore({
                query: AllSubrogationClaimsQuery,
                variables: {
                    ...variables,
                    first: currentLength,
                },
                updateQuery: (previousResult, { fetchMoreResult }) => {
                    const newEdges = fetchMoreResult.allSubrogationClaims.edges
                    const pageInfo = fetchMoreResult.allSubrogationClaims.pageInfo
                    return {
                        allSubrogationClaims: {
                            edges: [...newEdges],
                            pageInfo,
                            __typename: previousResult.allSubrogationClaims.__typename
                        },
                    }
                },
            })
        },
        loadMoreEntries: () => {
            return fetchMore({
                query: AllSubrogationClaimsQuery,
                variables: {
                    cursor: allSubrogationClaims.pageInfo.endCursor,
                    ...variables
                },
                updateQuery: (previousResult, { fetchMoreResult }) => {
                    const newEdges = fetchMoreResult.allSubrogationClaims.edges
                    const pageInfo = fetchMoreResult.allSubrogationClaims.pageInfo
                    return {
                        allSubrogationClaims: {
                            edges: [...previousResult.allSubrogationClaims.edges, ...newEdges],
                            pageInfo,
                            __typename: previousResult.allSubrogationClaims.__typename
                        },
                    }
                },
            })
        },
    })
})(SubrogationClaimList)
